module.exports = __webpack_public_path__ + "static/media/angular.1845776d.png";